// extracted by mini-css-extract-plugin
export default {"root":"Filters_root__95EeM","inputText":"Filters_inputText__AuHkp"};